// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-group--sub-group .v-list-group__header {\n  padding-left: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
